<template>
  <div>
    <header>
      <div class="title">
        <div class="img-container">
          <img v-if="theme"
            src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png"
            alt="待加载">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="none"></div>
        <div class="user-info">
          <!-- 返回主页按钮（仅批量生成中心显示） -->
          <div v-if="isBatchCenter" class="header-btn home-btn" @click="gohome">
            <span class="iconfont">&#xe66c;</span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe640;</span>
            <span>生图记录</span>
          </div>
          <!-- 支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe681;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>
    <div class="main">
      <div class="left_menu" v-show="!isBatchCenter">
        <div class="navigation">
          <div class="title_name">
            探索
          </div>
          <router-link to="/index/homepage" class="router">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe633;</span>
              <div>
                <span>模型广场</span>
              </div>
            </div>
          </router-link>
          <div class="title_name" v-if="hasPermission(['ai/d/m/basic']) && hasPermission(['ai/d/m/advanced'])">
            创作
          </div>
          <router-link to="/index/morejoyassistant" class="router" v-show="false">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe6a4;</span>
              <div>
                <span>Pandora</span>
                <span class="info-additional">(魔盒)</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/morejoyassistant_LLM" class="router">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe6a4;</span>
              <div>
                <span>提示词优化</span>
                <span class="info-additional">(文本生成)</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/morejoyassistant_script" class="router">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe6a4;</span>
              <div>
                <span>视频脚本生成</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/imageGeneration" class="router" v-permission="['ai/d/m/basic']" v-show="false">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xea1f;</span>
              <div>
                <span>AI创作</span>
                <span class="info-additional">(基础版)</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/generate" class="router" v-permission="['ai/d/m/advanced']" v-show="false">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe689;</span>
              <div>
                <span>AI创作</span>
                <span class="info-additional">(进阶版)</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/comfyui" class="router" v-show="false">
            <div class="nav-item">
              <span class="nav-name iconfont">&#xe621;</span>
              <div>
                <span>在线工作流</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/trainmodel" class="router" v-show="false">
            <div class="nav-item">
              <span class="nav-name iconfont">&#xe673;</span>
              <div>
                <span>训练模型</span>
              </div>
            </div>
          </router-link>
          <div class="title_name" v-show="false">
            个人中心
          </div>
          <div class="title_name">
            其他
          </div>
          <router-link to="/index/imagecenter" class="router">
            <div class="nav-item">
              <span class="nav-name iconfont">&#xe640;</span>
              <div>
                <span>批量生成中心</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/videosource" class="router">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe640;</span>
              <div>
                <span>视频素材库</span>
              </div>
            </div>
          </router-link>
          <router-link to="/index/appdownload" class="router" v-show="false">
            <div class="nav-item" @click="source_html()">
              <span class="nav-name iconfont">&#xe65b;</span>
              <div>
                <span>应用下载</span>
              </div>
            </div>
          </router-link>
          <router-link to="/servicemanual" class="router">
            <div class="nav-item">
              <span class="nav-name iconfont">&#xe634;</span>
              <div>
                <span>使用指南</span>
              </div>
            </div>
          </router-link>
        </div>
        <div class="none_box"></div>
        <div class="lab">
          实验室
        </div>
        <div class="setting">
          <div class="keyshort">
            <span class="type_module iconfont" id="keyshort" @click="handleShortCut">&#xe726; 快捷方式</span>
          </div>
          <div class="light">
            <span class="type_module iconfont" id="light">&#xe663; 深色模式</span>
            <div class="switch_button" @click="html_change">
              <span class="backg">
                <div class="label"></div>
                <span class="darktips iconfont">&#xe664;</span>
                <span class="daytips iconfont">&#xe665;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <router-view @show="handleShow"></router-view>
    </div>
    <el-dialog v-if="dialogData.visible" :append-to-body="true" :close-on-click-modal="false" :title="dialogData.title"
      :visible.sync="dialogData.visible" :width="dialogData.width" :is-full-screen="false">
      <component :is="dialogData.componentName" :father-data="dialogData.data" @closeDialog="hiddenDialog" />
    </el-dialog>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import UserImageInfo from '@/components/UserImageInfo/index.vue'
import { mapGetters, mapMutations } from 'vuex'
import { hasPermission } from '@/utils/helper/permissionHelper'
import setLocalStorage from '@/utils/setLocalStorage'
import theme from '@/utils/theme'
import { Message } from 'element-ui'
import { HOME } from '@/enums/common/modules'
export default {
  name: 'IndexPage',
  components: {
    'user-image-info': UserImageInfo
  },
  data() {
    return {
      stack: false,
      // 模态框
      dialogData: {
        visible: false, // 展示
        title: '', // 标题
        componentName: '', // 组件名
        data: {}, // 数据
        width: ''
      },
      day: theme.day,
      night: theme.night,
      theme: null,
      process_lock: false,
      autoSkipTimer: null, // 用于保存定时器
      // 评论区弹窗
      boardvisible: false,
      disscussType: null
    }
  },
  computed: {
    ...mapGetters(['avatar']),
    // 批量生成中心 / 视频素材库等自带内部布局的页面：隐藏左侧导航栏并显示返回主页
    isBatchCenter() {
      return ['/index/imagecenter', '/index/videosource'].includes(this.$route.path)
    }
  },
  created() {
    this.theme = setLocalStorage.getItem('theme')
    if (this.theme === '' || this.theme === null) {
      this.theme = true
    }
    this.parent_node = this.$store.getters['parent_node/sourceHomePageCover']
    // 将ID值赋给讨论区类型
    this.disscussType = HOME
  },
  mounted() {
    // 在组件挂载时添加事件监听器
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    // 初始化效果
    this.$nextTick(() => {
      this.source_html()
      // 实验室
      const light = document.querySelector('#light')
      const keyshort = document.querySelector('#keyshort')
      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')
      if (this.theme === false) {
        if (label) label.style.paddingLeft = '60%'
        if (darktips) darktips.style.opacity = 1
        if (daytips) daytips.style.opacity = 0
        if (light) light.style.color = 'gray'
        if (keyshort) keyshort.style.color = 'gray'
      } else {
        label.style.paddingLeft = '1%'
        darktips.style.opacity = 0
        daytips.style.opacity = 1
        light.style.color = 'black'
      }
    })
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听器，避免内存泄漏
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    // 清除定时器
    if (this.autoSkipTimer) {
      clearInterval(this.autoSkipTimer)
      this.autoSkipTimer = null
    }
  },
  methods: {
    // 展开讨论区
    handleShow(data) {
      this.boardvisible = data
    },
    // 查看快捷方式
    handleShortCut() {
      this.$emit('showShortCut', true)
    },
    ...mapMutations('theme', ['sourceTheme', 'changeStatus']),
    hasPermission,
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 跳转到生图记录页面
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈(讨论区)
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 展示模态框
    showDialog() {
      this.dialogData.visible = true
    },
    // 隐藏模态框
    hiddenDialog() {
      this.dialogData.visible = false
    },
    // 设置模态框数据
    setDialogData(title, componentName, data, width = '') {
      this.dialogData.title = title
      this.dialogData.componentName = componentName
      this.dialogData.data = data
      this.dialogData.width = width
    },
    // 页面过渡效果
    html_change() {
      if (this.$route.path !== '/index/homepage') {
        Message.error('试验模式暂不支持再当前页面切换模式,请回到主页!')
        this.autoSkipTimer = setTimeout(() => {
          if (this.$route.path !== '/index/homepage') {
            this.$router.push({
              path: '/index/homepage'
            })
          }
        }, 500)
        return
      }
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.right_menu')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 实验室
      const light = document.querySelector('#light')
      const keyshort = document.querySelector('#keyshort')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')

      // 讨论区状态
      const main = document.querySelector('.modal-overlay .main')
      const fixed = document.querySelector('.modal-overlay .main .fixed')
      main.style.background = this.theme ? this.night : this.day
      main.style.boxShadow = this.theme ? '0 0 50px rgba(255, 255, 255, 0.5)' : '0 0 20px rgba(0, 0, 0, 0.2)'
      fixed.style.background = this.theme ? this.night : this.day

      if (this.theme === true) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })

          header.childNodes.forEach(item => {
            item.style.opacity = 0.7
          })
          header.style.borderBottom = '1px solid gray'

          left.style.borderRight = '1px solid gray'
          light.style.color = 'gray'
          keyshort.style.color = 'gray'

          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
          daytips.style.opacity = 0
        } catch (error) {
          console.log(error)
        }
        this.theme = false
        this.changeStatus(this.theme)
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })

          header.childNodes.forEach(item => {
            item.style.opacity = 1
          })
          header.style.borderBottom = ''

          left.style.borderRight = ''
          light.style.color = 'black'
          keyshort.style.color = 'black'

          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
          daytips.style.opacity = 1
        } catch (e) {
          console.log(e)
        }
        this.theme = true
        this.changeStatus(this.theme)
      }
    },
    // 初始化效果
    source_html() {
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.right_menu')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 实验室
      const light = document.querySelector('#light')
      const keyshort = document.querySelector('#keyshort')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')
      if (this.theme === false) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })
          header.style.borderBottom = '1px solid gray'
          left.style.borderRight = '1px solid gray'
          light.children[0].style.color = 'gray'
          keyshort.children[0].style.color = 'gray'
          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
          daytips.style.opacity = 0
        } catch (error) {
        }
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })

          header.style.borderBottom = ''
          left.style.borderRight = ''
          light.children[0].color = 'black'
          keyshort.children[0].color = 'black'
          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
          daytips.style.opacity = 1
        } catch (e) {
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
  // background-color: #ffffff;
}

// body{
//   background-color: #ffffff!important;
// }

.router-link-active {
  transition: all 0.5s;
  background-color: @basicselect;
  border-radius: 15px;
  color: @font_black;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

header {
  height: 95px;
  width: 2560px;
  padding: 10px 30px 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid @basicselect;
  transition: all 0.5s;
  //overflow: hidden;

  .title {
    display: flex;
    color: @font_black;
    align-items: center;

    .img-container {
      width: 230px;
      height: 75px;
      display: flex;
      align-items: center;
      padding: 10px;

      img {
        width: 230px;
        object-fit: cover
      }
    }

    .none {
      width: 1800px;
    }

    .user-info {
      display: flex;
      gap: 20px;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;

      .header-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 24px;
        border-radius: 10px;
        background-color: rgba(39, 41, 46, 0.05);
        cursor: pointer;
        transition: all 0.3s;
        font-size: 16px;
        font-family: 'icomoon';
        color: @font_black;
        white-space: nowrap;
        .iconfont {
          font-size: 20px;
        }
        &:hover {
          background-color: @basicselect;
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }
      }

      .home-btn {
        background-color: #ff8c42;
        color: #fff;

        &:hover {
          background-color: #ff7a2e;
          box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
        }
      }

      .user-avatar {
        display: flex;
        width: 50px;
        height: 50px;
        border: 2px solid @basicselect;
        border-radius: 50%;
        overflow: hidden;
        justify-content: center;
        align-items: center;

        img {
          cursor: pointer;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.3s;

          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }

    .tips {
      display: flex;

      .tips_info {
        display: inline-block;
        font-size: 30px;
        padding: 5px;
      }
    }
  }
}

.main {
  display: flex;
  height: calc(100vh - 95px);
  width: 2560px;
  overflow: hidden;

  .left_menu {
    // background-color: @basecolor;
    width: 360px;
    color: @font_black;
    font-family: 'icomoon';
    border-right: 1px solid @basicselect;

    .navigation {
      display: flex;
      flex-direction: column;
      gap: 10px;
      height: calc(40vh - 95px);
      padding: 10px 30px 10px 30px;

      .title_name {
        font-size: 20px;
        color: rgb(115, 115, 115);
      }

      .router {
        text-decoration: none;
        color: @font_black;
      }

      .nav-item {
        display: flex;
        align-items: center;
        justify-content: left;
        padding-left: 35px;
        height: 85px;
        border-radius: 15px;
        transition: all 0.3s;
        cursor: pointer;
        border: 2px dashed rgba(255, 255, 255, 0);

        &:hover {
          border: 2px dashed @basicselect;
          padding-bottom: 5px;
        }

        .nav-name {
          display: inline-block;
          padding: 4px 15px 4px 4px;
          font-size: 28px;
          overflow: hidden;
        }

        .info-additional {
          line-height: 32px;
          font-size: 18px;
          color: #8c939d;
        }

        div {
          display: flex;

          span:nth-child(1) {
            display: inline-block;
            font-size: 23px;
          }
        }
      }
    }

    .none_box {
      height: 50vh;
    }

    .lab {
      font-size: 20px;
      color: @font_gray;
      padding-left: 35px;
    }

    .setting {
      position: relative;
      height: 10vh;
      cursor: pointer;
      color: @font_black;
      // background-color: #ff0000;

      .keyshort {
        position: absolute;
        left: 37%;
        top: 5%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        width: 300px;
        height: 40px;
        transition: all 0.3s;

        .type_module {
          display: block;
          top: 10%;
          left: 18%;
          width: 140px;
          padding: 5px;
          font-size: 23px;
          background-color: transparent;
        }

      }

      .light {
        position: absolute;
        left: 48%;
        top: 38%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        width: 300px;
        height: 40px;
        transition: all 0.3s;

        .type_module {
          display: block;
          top: 10%;
          left: 18%;
          width: 140px;
          padding: 5px;
          font-size: 23px;
          background-color: transparent;
        }

        .switch_button {
          position: relative;
          width: 80px;
          height: 25px;
          transition: all 0.5s;
          margin-top: 5px;

          .backg {
            display: block;
            width: 100%;
            height: 100%;
            padding: 2px;
            border-radius: 15px;
            background-color: rgb(52, 52, 52);
            z-index: 1;
            transition: all 0.5s;
          }

          .label {
            width: 21px;
            height: 21px;
            border-radius: 13px;
            background-color: @font_white;
            z-index: 2;
            transition: all 0.5s;
          }

          .darktips {
            position: absolute;
            color: rgb(252, 119, 22);
            font-size: 18px;
            top: 2px;
            right: 10px;
            display: block;
            width: 18px;
            height: 18px;
            opacity: 0;
            transition: all 0.5s;
          }

          .daytips {
            position: absolute;
            color: rgb(252, 119, 22);
            font-size: 18px;
            top: 4px;
            right: 10px;
            display: block;
            width: 18px;
            height: 18px;
            opacity: 1;
            transition: all 0.5s;
          }
        }
      }
    }

  }

}
</style>
